<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 控件后组件 -->
              <div class="switch">
                <el-switch v-model="istime" active-color="#67C23A" :class="istime ? 'active' : 'inactive'"
                  @change="toggleSwitch">
                </el-switch>
                <div class="txt">结款提醒</div>
              </div>
            </template>
          </FormItem>
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";

export default {
  mixins: [detailMixin, orderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "订单管理", path: "/order/contract" },
        { name: "合同订单", path: "/order/contract" },
        { name: "订单添加" },
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "drtel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          viewMode: true,
        },
        {
          label: "装货重量（吨）",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货日期",
          keyName: "starttime",
          err: "请填写装货日期",
          type: "text",
          viewMode: true,
        },
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "ertel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          viewMode: true,
        },
        {
          label: "卸货重量（吨）",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
          viewMode: true,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "公司单价（元/吨）",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "司机单价（元/吨）",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
